export function IsTargetBlock(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.added !== undefined || b.removed !== undefined || b.updated !== undefined;
}
export function hasTileSelectionContext(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.setContext !== undefined;
}
export function isViewProxy(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.view !== undefined;
}
//# sourceMappingURL=tiles.pipeline.interfaces.js.map